import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import SearchIcon from '@tradera/tradera-ui/icons/search.svg?jsx';
import ArrowUpIcon from '@tradera/tradera-ui/icons/arrow-up.svg?jsx';
import ArrowDownIcon from '@tradera/tradera-ui/icons/arrow-down.svg?jsx';

function CategoryListView(props) {
    const {
        filter,
        filteredCategories,
        handleFilterKey,
        handleFilterChange,
        handleFilterBlur,
        scrollTo,
        toggleCategory,
        getBackToTopButtonRef
    } = props;
    return (
        <Fragment>
            <div className="category-list container">
                <div className="row">
                    <div className="col-md-3 col-sm-12 order-1 order-md-0">
                        <div className="form-control-with-icon mr-md-4">
                            <input
                                type="text"
                                className="form-control my-3"
                                placeholder="Sök bland kategorier"
                                value={filter}
                                onKeyDown={handleFilterKey}
                                onChange={handleFilterChange}
                                onBlur={handleFilterBlur}
                            />
                            <SearchIcon className="icon icon-dark" />
                        </div>
                    </div>
                    <div className="col-md-9 order-0 order-md-0">
                        <h1 className="mb-3" id="top" data-scroll-target="top">
                            {filter
                                ? `Kategorier som matchar "${filter}"`
                                : 'Kategorier'}
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 d-md-block d-none">
                        <div className="card mr-4">
                            <ul className="mb-0">
                                {filteredCategories.length > 0 ? (
                                    filteredCategories.map(category => (
                                        <li key={category.title}>
                                            <a
                                                href={'#' + category.title}
                                                data-scroll-to={category.title}
                                                onClick={scrollTo}>
                                                {category.title}
                                            </a>
                                        </li>
                                    ))
                                ) : (
                                    <p>Inga matchande kategorier hittade</p>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="card">
                            {filteredCategories.length > 0 ? (
                                <ul className="mb-0">
                                    {filteredCategories.map(
                                        (category, index) => (
                                            <li
                                                key={category.title}
                                                className="py-0"
                                                data-scroll-target={
                                                    category.title
                                                }>
                                                <h3
                                                    id={category.title}
                                                    className="category-title my-3 d-md-block d-none">
                                                    {category.title}
                                                </h3>
                                                <div className="d-md-none">
                                                    <div
                                                        className={`category-header row align-items-center ${
                                                            filter
                                                                ? ''
                                                                : 'cursor-pointer'
                                                        }`}
                                                        onClick={() =>
                                                            toggleCategory(
                                                                category
                                                            )
                                                        }>
                                                        <div className="col-auto">
                                                            <LazyLoad
                                                                height={0}
                                                                offset={400}
                                                                once>
                                                                {category.id ? (
                                                                    <img
                                                                        className="category-header-image"
                                                                        srcSet={`/static/images/category-mobile/${
                                                                            category.id
                                                                        }.jpg 1x,
                                                                        /static/images/category-mobile/${
                                                                            category.id
                                                                        }@2x.jpg 2x`}
                                                                    />
                                                                ) : (
                                                                    <div className="category-header-image" />
                                                                )}
                                                            </LazyLoad>
                                                        </div>
                                                        <h6
                                                            id={category.title}
                                                            className={`col my-3 ${
                                                                category.open
                                                                    ? 'font-weight-bold'
                                                                    : ''
                                                            }`}>
                                                            {category.title}
                                                        </h6>
                                                        <div className="col-auto">
                                                            {!filter && (
                                                                <Fragment>
                                                                    {category.open ? (
                                                                        <ArrowUpIcon className="icon icon-sm icon-dark" />
                                                                    ) : (
                                                                        <ArrowDownIcon className="icon icon-sm icon-dark" />
                                                                    )}
                                                                </Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <ul
                                                    className={`category-groups my-3 text-columns-lg-4 text-columns-sm-2 ${
                                                        category.open
                                                            ? ''
                                                            : 'd-none d-md-block'
                                                    }`}>
                                                    {category.categoryNodes.map(
                                                        group => (
                                                            <li
                                                                key={
                                                                    group.title
                                                                }>
                                                                <a
                                                                    className={
                                                                        group.isTopLevel
                                                                            ? 'font-weight-bold font-underlined'
                                                                            : ''
                                                                    }
                                                                    href={
                                                                        group.href
                                                                    }>
                                                                    {
                                                                        group.title
                                                                    }
                                                                </a>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                                {index <
                                                    filteredCategories.length -
                                                        1 && (
                                                    <div className="border-bottom d-md-none" />
                                                )}
                                            </li>
                                        )
                                    )}
                                </ul>
                            ) : (
                                <p>Inga matchande kategorier hittade</p>
                            )}
                        </div>
                    </div>
                </div>
                <a
                    role="button"
                    href="#top"
                    className="btn btn-primary btn-shadow btn-floating d-none"
                    data-scroll-to="top"
                    onClick={scrollTo}
                    ref={getBackToTopButtonRef}>
                    <span className="d-none d-md-inline">
                        Tillbaka till toppen
                    </span>
                    <ArrowUpIcon className="icon icon-white icon-after" />
                </a>
            </div>
        </Fragment>
    );
}

CategoryListView.propTypes = {
    filter: PropTypes.string,
    filteredCategories: PropTypes.arrayOf(PropTypes.object),
    handleFilterKey: PropTypes.func,
    handleFilterChange: PropTypes.func,
    handleFilterBlur: PropTypes.func,
    scrollTo: PropTypes.func,
    toggleCategory: PropTypes.func,
    getBackToTopButtonRef: PropTypes.func
};

export default CategoryListView;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/category-list/category-list-view.jsx